export function checkKeydownDecimalValue(e: any) {
  if (
    e.ctrlKey ||
    e.metaKey ||
    ["Backspace", "Delete", "ArrowLeft", "ArrowRight"].includes(e.key)
  ) {
    return;
  }

  if (e.key === "." && e.currentTarget.value.includes(".")) {
    e.preventDefault();
  }

  if (!/^[0-9.]$/.test(e.key)) {
    e.preventDefault();
  }
}

export function onInputCheckDecimal(e: any) {
  e.currentTarget.value = e.currentTarget.value.replace(/[^0-9.]/g, "");

  const parts = e.currentTarget.value.split(".");
  if (parts.length > 2) {
    e.currentTarget.value = parts[0] + "." + parts.slice(1).join("");
  }
}

export function onPasteCheckDecimal(e: any) {
  e.preventDefault();
  const pastedText = e.clipboardData.getData("text");

  const sanitized = pastedText.replace(/[^0-9.]/g, "");
  const parts = sanitized.split(".");
  const validValue =
    parts.length > 2 ? parts[0] + "." + parts.slice(1).join("") : sanitized;

  document.execCommand("insertText", false, validValue);
}

export function sanitizeEsignatureInput(value: string): string {
  if (!value) return "";
  let s = value;
  s = s.replace(/[\uD83C-\uDBFF][\uDC00-\uDFFF]/g, "");
  s = s.replace(
    /[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?<![\uD800-\uDBFF])[\uDC00-\uDFFF]/g,
    ""
  );
  s = s.replace(/[\uFE00-\uFE0F]/g, "");
  return s;
}
